import { normalize, schema, denormalize } from 'normalizr';

const period = new schema.Entity('periods', {}, { idAttribute: 'id' });

export function normalizeDatos(myData) {
  const mySchema = { periods: [period] };
  const normalizedData = normalize(myData, mySchema);
  return normalizedData;
}

export function normalizeDato(myData) {
  const mySchema = period;
  const normalizedData = normalize(myData, mySchema);

  return normalizedData;
}

export function denormalizeDato(myData, store) {
  const mySchema = period;

  const normalizedData = denormalize(myData, mySchema, store);

  return normalizedData;
}

export default period;
